import { useEffect, useState, useCallback } from 'react'
import './style.css'
import JobCard from './JobCard'
import { FilterBox, MobileFilterModal } from '../../Components/Filter'
import Pagination from 'react-js-pagination'
import Base from '../../Components/Layout/Base'
import { useSelector, useDispatch } from 'react-redux'
import { fetchJob } from '../../Redux/Actions/jobBoard'
import { ACTIVE_PAGE, SET_LOCAL_FILTER } from '../../Redux/Actions/types'
import { useNavigate, useSearchParams } from 'react-router-dom'
import filter from '../../Assets/images/filter.svg'
import nojob from '../../Assets/images/noJobs.png'
import { fetchNormalSubmission, getProfile, introVideoDetails } from '../../Redux/Actions/ProfileSteps'
import { getKidList } from '../../Redux/Actions/dashboard'

const JobBoard = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const jobs = useSelector((s) => s.jobBoard.jobs)
  const internJobs = useSelector((s) => s.jobBoard.internJobs)
  const activePage = useSelector((s) => s.jobBoard.activePage)
  const localFilter = useSelector((s) => s.jobBoard.localFilter)
  const [filterModal, setFilterModal] = useState(false)
  const kids = useSelector((state) => state.dashboard.kids)
  let test
  const [activeTab, setActiveTab] = useState('fulltime')
  useEffect(() => {
    if (!kids) {
      dispatch(getKidList())
    } else if (kids[0]?.id) {
      dispatch(getProfile(kids[0]?.id))
      dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id }))
      dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
    }
  }, [kids])

  const handleInternships = useCallback(() => {
    setActiveTab('internships')
    setThePage(0)
    navigate('?internship', { replace: true })

    dispatch({
      type: SET_LOCAL_FILTER,
      payload: { job_types: ['INTERNSHIPTWOMONTHS', 'INTERNSHIPSIXMONTHS'] },
    })
    dispatch(
      fetchJob({ pageNo: 0, pageSize: 6 }, 'internships', {
        job_types: ['INTERNSHIPTWOMONTHS', 'INTERNSHIPSIXMONTHS'],
      }),
    )
  }, [dispatch, navigate])

  const handleFullTime = useCallback(() => {
    setThePage(0)
    setActiveTab('fulltime')
    navigate('?fulltime', { replace: true })

    dispatch({
      type: SET_LOCAL_FILTER,
      payload: { job_types: ['FULLTIME'] },
    })
    dispatch(
      fetchJob({ pageNo: 0, pageSize: 6 }, 'fulltime', {
        job_types: ['FULLTIME'],
      }),
    )
  }, [dispatch, navigate])

  useEffect(() => {
    if (searchParams.has('internship')) {
      handleInternships()
    } else if (searchParams.has('fulltime')) {
      handleFullTime()
    } else {
      handleFullTime()
    }
  }, [searchParams, handleInternships, handleFullTime])

  const handleFilterChange = (obj) => {
    const payload = { ...localFilter }
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: { ...payload, ...obj },
    })
  }

  const handleResetFilter = (obj) => {
    dispatch({
      type: SET_LOCAL_FILTER,
      payload: {},
    })
    dispatch(fetchJob({ pageNo: 0, pageSize: 6 }, activeTab, activeTab === 'fulltime' ? { job_types: ['FULLTIME'] } : { job_types: ['INTERNSHIPTWOMONTHS', 'INTERNSHIPSIXMONTHS'] }))
  }

  const applyFilter = () => {
    dispatch(fetchJob({ pageNo: 0, pageSize: 6 }, activeTab, { ...localFilter }))
  }

  const setThePage = (page) => {
    dispatch({
      type: ACTIVE_PAGE,
      payload: page,
    })
  }

  const handlePageChange = (pageNumber) => {
    const page = pageNumber - 1
    setThePage(page)
    dispatch(
      fetchJob({ pageNo: page, pageSize: 6 }, activeTab, {
        ...localFilter,
        job_types: activeTab === 'fulltime' ? ['FULLTIME'] : ['INTERNSHIPTWOMONTHS', 'INTERNSHIPSIXMONTHS'],
      }),
    )
  }

  return (
    <Base>
      <div className="container-fluid section-bottom-padding">
        <div className="d-flex justify-content-between align-items-center pt-5 py-4">
          <ul className="nav nav-tabs cstm-tabs my-0" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button className={`nav-link ${activeTab === 'fulltime' ? 'active' : ''}`} type="button" role="tab" aria-selected={activeTab === 'fulltime'} onClick={handleFullTime}>
                Full Time
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button className={`nav-link ${activeTab === 'internships' ? 'active' : ''}`} type="button" role="tab" aria-selected={activeTab === 'internships'} onClick={handleInternships}>
                Internships
              </button>
            </li>
          </ul>
          <div className="text-end d-flex d-lg-none filter-icon-img" type="button" onClick={() => setFilterModal(true)}>
            <img src={filter} alt="Filter" className="me-2" />
            Filters
          </div>
        </div>

        <div className="d-lg-none">
          <MobileFilterModal
            onShow={filterModal}
            onClose={() => setFilterModal(false)}
            handleFilterChange={handleFilterChange}
            type={activeTab}
            applyFilter={applyFilter}
            handleFilterReset={handleResetFilter}
          />
        </div>

        <div className="row">
          <div className="col-lg-3 d-none d-lg-block">
            <div className="fiter-bg">
              <FilterBox handleFilterChange={handleFilterChange} applyFilter={applyFilter} handleResetFilter={handleResetFilter} type={activeTab} />
            </div>
          </div>

          <div className="col-lg-9">
            {activeTab === 'fulltime' ? (
              <>
                <div className="row">
                  {jobs?.data?.length > 0 ? (
                    jobs.data.map((item) => (
                      <div className="col-lg-4 mb-4" key={item.id}>
                        <JobCard item={item} onCardClick={() => navigate('/job-detail?fulltime', { state: { data: item } })} />
                      </div>
                    ))
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <img src={nojob} alt="No data" className="w-25 justify-content-center align-items-center d-flex mb-3" />
                      <h3>No jobs Matching your filter criteria!</h3>
                      <p>We are working on adding more opportunities, kindly check back later.</p>
                    </div>
                  )}
                </div>

                {jobs?.data?.length > 0 && (
                  <div className="pagination-container justify-content-center d-flex">
                    <Pagination
                      activePage={activePage + 1}
                      itemsCountPerPage={6}
                      totalItemsCount={jobs?.pagination_info?.total_elements}
                      pageRangeDisplayed={6}
                      linkClass="custm_pagination"
                      onChange={handlePageChange}
                      itemClassFirst="page_first"
                      itemClassPrev="page_prev"
                      itemClassNext="page_next"
                      itemClassLast="page_last"
                    />
                  </div>
                )}
              </>
            ) : (
              <>
                <div className="row">
                  {internJobs?.data?.length > 0 ? (
                    internJobs.data.map((item) => (
                      <div className="col-lg-4 mb-4" key={item.id}>
                        <JobCard item={item} onCardClick={() => navigate('/job-detail?internship', { state: { data: item } })} />
                      </div>
                    ))
                  ) : (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <img src={nojob} alt="No data" className="w-25 justify-content-center align-items-center d-flex mb-3" />
                      <h3>No jobs Matching your filter criteria!</h3>
                      <p>We are working on adding more opportunities, kindly check back later.</p>
                    </div>
                  )}
                </div>

                {internJobs?.data?.length > 0 && (
                  <div className="pagination-container justify-content-center d-flex mb-4">
                    <Pagination
                      activePage={activePage + 1}
                      itemsCountPerPage={6}
                      totalItemsCount={internJobs?.pagination_info?.total_elements}
                      pageRangeDisplayed={6}
                      linkClass="custm_pagination"
                      onChange={handlePageChange}
                      itemClassFirst="page_first"
                      itemClassPrev="page_prev"
                      itemClassNext="page_next"
                      itemClassLast="page_last"
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Base>
  )
}

export default JobBoard
